var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.selections),function(ref){
var id = ref.id;
var name = ref.name;
return _c('div',{key:id},[_vm._v("\n    "+_vm._s(_vm._f("translate")(name))+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }